module.exports = __webpack_public_path__ + "assets/img/kv-539e80c8.jpg";